<div *ngIf="isLoading">
  <div class="loading-card">
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
    <div class="loading-skeleton-bar"></div>
  </div>
</div>

<div *ngIf="!isLoading && tableData && tableData?.length > 0; else emptyTable">
  <div
    class="button-container"
    style="display: flex; justify-content: flex-end; gap: 10px"
  >
    <kodit-button
      (btnClicked)="exportToExcel()"
      btnIcon="fas fa-file-excel"
      btnLabel="Izvezi u Excel"
      btnClass="p-button-outlined"
    ></kodit-button>
    <kodit-button
      (btnClicked)="exportToPDF()"
      btnIcon="fas fa-file-pdf"
      btnLabel="Izvezi u PDF"
      btnClass="p-button-outlined"
    ></kodit-button>
  </div>
  <div id="printable-content">
    <div class="printable-content-zaglavlje">
      <div class="header">
        <div class="title">
          Knjiga o ostvarenom prometu paušalno oporezovanih obveznika
        </div>
      </div>
    </div>

    <p-table [value]="tableData" class="custom-table">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 25%; text-align: left">Datum i opis knjiženja</th>
          <th style="width: 25%; text-align: right">
            Od prodaje proizvoda (RSD)
          </th>
          <th style="width: 25%; text-align: right">
            Od izvršenih usluga (RSD)
          </th>
          <th style="width: 25%; text-align: right">
            Ukupni prihodi od delatnosti (RSD)
          </th>
        </tr></ng-template
      >

      <ng-template let-rowData pTemplate="body">
        <tr>
          <td style="text-align: left">
            {{ rowData.datumKnjizenja }} -
            {{ rowData.brojFakture ?? 'DNEVNI PAZAR' }}
          </td>
          <td style="text-align: right">
            {{ rowData.iznosRoba | number: '1.2-4' }}
          </td>
          <td style="text-align: right">
            {{ rowData.iznosUsluga | number: '1.2-4' }}
          </td>
          <td style="text-align: right">
            {{ rowData.ukupniPrihodi | number: '1.2-4' }}
          </td>
        </tr>
      </ng-template>
      <ng-template class="footer" pTemplate="footer">
        <tr>
          <td colspan="4" style="text-align: left">
            Za celokupan izveštaj molimo vas preuzmite
            <kodit-button
              btnClass="p-button-text p-p-0"
              btnLabel="Excel"
              (btnClicked)="exportToExcel()"
            ></kodit-button>
            ili
            <kodit-button
              btnClass="p-button-text p-p-0"
              btnLabel="PDF"
              (btnClicked)="exportToPDF()"
            ></kodit-button>
            dokument
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<ng-template #emptyTable>
  <div *ngIf="!isLoading" id="printable-content">
    <div class="printable-content-zaglavlje">
      <div class="header">
        <div class="title">
          Knjiga o ostvarenom prometu paušalno oporezovanih obveznika
        </div>
      </div>
    </div>

    <p-table [value]="[loadingData[0]]" class="custom-table">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 25%; text-align: left">Datum i opis knjiženja</th>
          <th style="width: 25%; text-align: right">
            Od prodaje proizvoda (RSD)
          </th>
          <th style="width: 25%; text-align: right">
            Od izvršenih usluga (RSD)
          </th>
          <th style="width: 25%; text-align: right">
            Ukupni prihodi od delatnosti (RSD)
          </th>
        </tr></ng-template
      >

      <ng-template pTemplate="body">
        <tr>
          <td
            colspan="4"
            class="p-text-center"
            style="font-size: 24px; padding: 200px !important"
          >
            Nema podataka
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</ng-template>
